import React, { createContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWrapper } from '../../shared/api/fetchWrapper';

export const FlowChartContext = createContext();

export const FlowChartProvider = ({ children }) => {
  const navigate = useNavigate();
  
  // State for selected shape and workflow data
  const [selectedShape, setSelectedShape] = useState(null);
  const [workflowData, setWorkflowData] = useState(null);
  const [requestFiles, setRequestFiles] = useState(null); // Request file listesi
  
  // Save workflow function for FlowChart component
  const saveWorkflow = async (workflowData, TICID = null) => {
    const token = localStorage.getItem('token');
    const saveProcessId = process.env.REACT_APP_SAVE_FLOWCHART_GEOMETRY;
    
    try {
      const requestData = {
        token: token,
        process: saveProcessId,
        ...(TICID && { TICID: TICID }),
        ...workflowData
      };
      
      const response = await fetchWrapper(saveProcessId, requestData, navigate);
      
      if (response && response.result) {
        return { success: true, data: response };
      } else {
        return { success: false, error: response?.message || 'Save failed' };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Save script function for Code Panel
  const saveScript = async (shapeId, script, TICID = null) => {
    const token = localStorage.getItem('token');
    const saveScriptProcessId = process.env.REACT_APP_SAVE_SCRIPT; // Default process ID
    
    try {
      const requestData = {
        token: token,
        process: saveScriptProcessId,
        ...(TICID && { TICID: TICID }),
        id: shapeId,
        script: script
      };
      
      const response = await fetchWrapper(saveScriptProcessId, requestData, navigate);
      
      
      if (response && response.result) {
        return { success: true, data: response };
      } else {
        return { success: false, error: response?.message || 'Script save failed' };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const contextValue = {
    saveWorkflow,
    saveScript,
    selectedShape,
    setSelectedShape,
    workflowData,
    setWorkflowData,
    requestFiles,
    setRequestFiles
  };

  return (
    <FlowChartContext.Provider value={contextValue}>
      {children}
    </FlowChartContext.Provider>
  );
}; 